import React, { Component } from 'react';
import { Progress, Table } from 'reactstrap';
import { connect } from 'react-redux';

import './styles.scss';
// import Marquee from '@components/Marquee';
import { APP_TYPES, BRAND, defaultUnits } from '@config';
import { APP_TEXTS } from '../../../../texts/texts';
import { isICCorCSA, prepareNum, unitTransform, getInteractionMaximumValue } from '@services/helper.service';
import Spinner from '@components/LoadingStyles/Spinner';
import { DISTANCE } from '@reducers/units';
import { brandList, countryList, standardList } from '@src/app.values';
import { EmbedmentOptions } from '@reducers/selectors/design';

class CalculateHeader extends Component {

  state = {
    isMarqueePopup: true
  };

  render() {
    return (
      <div className="calculation">
        <section className="list-type calculation-header">
          <b>{this.props.titleText} <span className="text-uppercase">{this.props.titleContent}</span></b>
          <div className="d-flex">
            <div className="d-flex image-container">
              <img src={this.props.imageSrc || 'https://via.placeholder.com/200x60'} alt="" />
            </div>

            {this.props.appType !== APP_TYPES.REBAR_REINFORCEMENT && (
              <Table className="w-50">
                <tbody className="tbody">
                  <tr>
                    <th scope="row">{APP_TEXTS.CALCULATE_HEADER_TENSILE.Content}</th>
                    <td>
                      <Progress 
                        className="bg-white"
                        color={colorFromStatusValue(this.props.selectedItem, this.props.tensilePercentage)} 
                        value={this.props.tensilePercentage}>{this.props.tensilePercentage}%
                      </Progress>
                    </td>
                    <td><span className={getStateIcon(this.props.selectedItem, this.props.tensilePercentage)}/></td>
                  </tr>
                  <tr>
                    <th scope="row">{APP_TEXTS.CALCULATE_HEADER_SHEAR.Content}</th>
                    <td>
                      <Progress 
                        className="bg-white"
                        color={colorFromStatusValue(this.props.selectedItem, this.props.shearPercentage)} 
                        value={this.props.shearPercentage}>{this.props.shearPercentage}%
                      </Progress>
                    </td>
                    <td><span className={getStateIcon(this.props.selectedItem, this.props.shearPercentage)}/></td>
                  </tr>
                  <tr>
                    <th scope="row">{APP_TEXTS.ANCHOR_SELECTION_UTILIZATION.Content}</th>
                    <td>
                      <Progress 
                        className="bg-white"
                        color={colorFromStatusValue(
                          this.props.selectedItem, 
                          this.props.utilizationPercentage,
                          getInteractionMaximumValue(this.props.selectedItem, this.props.designStandard))} 
                        value={this.props.utilizationPercentage / 
                          getInteractionMaximumValue(this.props.selectedItem, this.props.designStandard) * 100 }
                      >
                        {this.props.utilizationPercentage}%
                      </Progress>
                    </td>
                    <td><span className={getStateIcon(
                      this.props.selectedItem, 
                      this.props.utilizationPercentage,
                      getInteractionMaximumValue(this.props.selectedItem, this.props.designStandard))}/></td>
                  </tr>
                </tbody>
              </Table>
            )}
          </div>
          
          {this.props.selectedItem && this.props.selectedItem.DesignMethodUsed && (
            <b>
              <span className="design-method">{APP_TEXTS.CALCULATE_HEADER_DESIGN_METHOD_LABEL.Content} 
              {this.props.selectedItem.DesignMethodUsed}
              </span>
              </b>
          )}
        </section>

        <div className="calculation-errors">
          {this.props.isWaitingForErrors && <Spinner /> }
            {this.props.errorMessages && this.props.errorMessages.length > 0 && (
              <ul>
                {this.props.errorMessages.map && this.props.errorMessages.map((text) => (
                  <li key={text + Date.now}>
                    <span className="icon_cancel" />
                    {text}
                  </li>
                ))}
              </ul>
            )}
            {BRAND === brandList.Spit && Number(this.props.country) === countryList['France'] &&
              (Number(this.props.designStandard) === standardList['EU'] ||
              Number(this.props.designStandard) === standardList['AnnexC']) &&
              null !== this.props.fixedAnchorageDepth &&
              this.props.fixedAnchorageDepth.specify === true &&
              this.props.fixedAnchorageDepth.embedmentOption === EmbedmentOptions.standard &&
              this.props.selectedItem.IsChemical &&
              this.props.selectedItem.Status === 0 && (
                <ul>
                  <li key="EmbedmentInfo" className='calculation-info-message'>
                    <span className="icon_info_message" />
                    {APP_TEXTS.EMBEDMENT_DEPTH_INFO_MESSAGE.Content}
                  </li>
                </ul>
            )}
        </div>
        
      </div>
    );
  }

}

const mapState = state => {
  const data = state.selectors.calculate[state.main.appType];

  if (data && data.gridSelectedItem) {
    return {
      titleText: state.main.appType === APP_TYPES.REBAR_REINFORCEMENT ? 
        APP_TEXTS.CALCULATE_HEADER_REBAR_SELECTED.Content : APP_TEXTS.CALCULATE_HEADER_ANCHOR_SELECTED.Content,
      titleContent: (() => {
        if (state.main.appType === APP_TYPES.REBAR_REINFORCEMENT) {
          const title = data.gridSelectedItem.DisplayName;

          return title || 'xxxx';
        } else {
          const title = anchorName(data.gridSelectedItem, state.main.units.distance, state.main.localization.designStandard);

          return title || 'put here dynamic anchor title';
        }
      })(),
      selectedItem: data.gridSelectedItem,
      imageSrc: data.anchorImageSrc,
      errorMessages: data.errorMessages,
      isWaitingForErrors: data.isWaitingForErrors,

      tensilePercentage: toPercentage(data.gridSelectedItem, data.gridSelectedItem.BetaN, 
        isICCorCSA(state.main.localization.designStandard) ? 1 : 2),
      shearPercentage: toPercentage(data.gridSelectedItem, data.gridSelectedItem.BetaV, 
        isICCorCSA(state.main.localization.designStandard) ? 1 : 2),
      utilizationPercentage: toPercentage(data.gridSelectedItem, data.gridSelectedItem.Beta, 
        isICCorCSA(state.main.localization.designStandard) ? 1 : 2),

      appType: state.main.appType,
      country: state.main.localization.country,
      designStandard: state.main.localization.designStandard,
      fixedAnchorageDepth: state.selectors.design[state.main.appType].fixedAnchorageDepth || null
    };
  }

  return {
    appType: state.main.appType,
    titleText: state.main.appType === APP_TYPES.REBAR_REINFORCEMENT ? 'Rebar selected' : 'Anchor selected',
  };
};

export default connect(mapState)(CalculateHeader);

function anchorName(selItem, distanceUnit, designStandard) {
  if(!selItem)
    return '';
  
  if(selItem.IsChemical) {
    let hef = 0;
    if (isICCorCSA(designStandard)) {
      hef = unitTransform(selItem.hef, true)
        .from(defaultUnits.DISTANCE)
        .to(distanceUnit === DISTANCE.INCHES ? DISTANCE.FRACTIONAL_INCHES : distanceUnit);
    } else {
      hef = prepareNum(unitTransform(selItem.hef, true).from(defaultUnits.DISTANCE).to(distanceUnit), false, 2, true);
    }
    return selItem.AnchorProduct + ' ' + selItem.AnchorType + ' x ' + hef;
  }
  else
    return selItem.AnchorProduct + ' ' + selItem.AnchorType;
}

function toPercentage (selItem, num, decimals = 2) {
  if(selItem){
    if(selItem.Status === '2')
      return 0;
    else
      return num ? (num * 100).toFixed(decimals) : 0;
  }
  return 0;
}

function getStateIcon(selItem, num, maximumValue = 100){
  if(selItem){
    if(Number(selItem.Status) === 2)
      return 'icon_invalid';
    else if (Number(selItem.Status) === 3)
      return 'icon_timeout';
    else {
      if(0 <= num && num <= maximumValue)
        return 'icon_check';
      else if(num > maximumValue)
        return 'icon_uncheck';
      else
        return 'icon_invalid';
    }
  }
  return 'icon_invalid';
}

function colorFromStatusValue(selItem, num, maximumValue = 100){
  if(selItem) {
    if(selItem.Status === '2')
      return 'danger';
    else {
      if(0 <= num && num <= maximumValue)
        return 'success';
      else 
        return 'danger';
    }
  }
  else
    return "danger";
}



// WEBPACK FOOTER //
// ./src/views/Calculate/components/CalculateHeader/index.js